import { memo, useEffect, useMemo, useState } from 'react';
import VideoUser from 'presentations/views/components/atoms/VideoUser';
import { LiveUser } from 'presentations/api/schema/user';

interface Props {
  liveUsers: LiveUser[];
  localUserId: string;
  localPageId: string | null;
  isShowIcon: boolean;
}

const Component = memo((props: Props) => {
  const [moveUsers, setMoveUsers] = useState<any>({});

  useEffect(() => {
    const dispatchMoveUsersEvent = (e: CustomEvent<any>) => {
      setMoveUsers(e.detail);
    };
    document.addEventListener(
      'MoveUsers',
      dispatchMoveUsersEvent as EventListener,
    );
    return () =>
      document.removeEventListener(
        'MoveUsers',
        dispatchMoveUsersEvent as EventListener,
      );
  }, []);

  const users = [];

  const liveUsers = Object.entries(props.liveUsers);
  for (const l of liveUsers) {
    const liveUser = l[1];
    if (liveUser.uid === props.localUserId) continue;
    let display = !props.isShowIcon ? 'none' : liveUser.display;
    if (props.localPageId !== liveUser.pageId) {
      display = 'none';
    }
    const position = moveUsers[liveUser.uid];
    if (!position) continue;
    const style = {
      left: position.x + 24,
      top: position.y - 0,
      display,
      transition: '1s',
    };
    users.push(
      <VideoUser
        key={liveUser.uid}
        name={liveUser.name}
        color={liveUser.color}
        style={style}
        isLocalPerson={false}
      />,
    );
  }
  return <>{users}</>;
});

export default Component;
